import { render, staticRenderFns } from "./RevenueList.vue?vue&type=template&id=920e988a&scoped=true"
import script from "./RevenueList.vue?vue&type=script&lang=js"
export * from "./RevenueList.vue?vue&type=script&lang=js"
import style0 from "./RevenueList.vue?vue&type=style&index=0&id=920e988a&prod&scoped=true&lang=css"
import style1 from "./RevenueList.vue?vue&type=style&index=1&id=920e988a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920e988a",
  null
  
)

export default component.exports